import { css } from "@emotion/react";

export const twoColumnLayoutCss = css`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: scroll;
`;

export const columnCss = css`
  flex: 1; // Each column takes 50%
  padding: 24px;
  overflow-y: auto; // Make each column scrollable
  height: 100%;

  &:first-of-type {
    border-right: 1px solid #e0e0e0; // Separator line
  }
`;

export const columnHeaderCss = css`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 24px;
  text-align: center; // As requested in mockup
`;

export const contentBodyCss = css`
  white-space: pre-wrap; // Preserves email formatting (newlines, etc.)
  line-height: 1.6;
  font-family: monospace; // Often better for raw email text
`;

export const analysisItemCss = css`
  margin-bottom: 24px;

  & > strong {
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #333;
    text-transform: uppercase;
  }

  & > p {
    font-size: 14px;
    color: #555;
    white-space: pre-wrap; // Preserve newlines in insights/summary
    line-height: 1.5;
  }
`;
